import { CommonModule, getCurrencySymbol } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ClaimService, CommonService, PaymentModeService } from '@fitness-force/api';
import { CONSTANTS_DATA } from '@fitness-force/constants';
import { PayModeLevel1, PayModeLevel2, Status } from '@fitness-force/enum';
import { ErrorMsgComponent, NotFoundError } from '@fitness-force/errors';
import { Claim, ListPaymentModeLevel2CountryMappingResponse, ListPaymentModeMastersResponse, PaymentModeMastersResponse, PaymentSignUp, TENANTSINTERFACE } from '@fitness-force/models';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputMaskModule } from 'primeng/inputmask';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { RadioButtonModule } from 'primeng/radiobutton';
import { StyleClassModule } from 'primeng/styleclass';
import { BehaviorSubject, Observable } from 'rxjs';
import { CurrencyformatPipe } from '@fitness-force/pipes/currency';
import { CommmonPipeModule } from '@fitness-force/pipes/common-pipes'
import { COMPANY_INFO, COUNTRY_MASTER_STATE, TENANTS_INFO } from 'apps/ff-frontend/src/app/state/app.state';
import { environment } from 'apps/ff-frontend/src/environments/environment';
import { Store } from '@ngrx/store';
import { CheckboxModule } from 'primeng/checkbox';
import { DatePickerModule } from 'primeng/datepicker';
import { MessageModule } from 'primeng/message';

import Statsig from 'statsig-js';
import { InputNumberComponent } from 'libs/shared/src/lib/components/input-number/input-number.component';
import { DirectivesSharedModule } from 'libs/shared/src/lib/directives/directives.module';

@Component({
  selector: 'other-payment',
  templateUrl: './other-payment.component.html',
  styleUrls: ['./other-payment.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    FormsModule,
    InputTextModule,
    ReactiveFormsModule,
    RadioButtonModule,
    InputNumberModule,
    CommonModule,
    StyleClassModule,
    DialogModule,
    ButtonModule,
    InputMaskModule,
    CommmonPipeModule,
    CurrencyformatPipe,
    CheckboxModule,
    DatePickerModule,
    MessageModule,
    InputNumberComponent,
    ErrorMsgComponent,
    DirectivesSharedModule,
    TranslateModule
]
})
export class OtherPaymentComponent implements OnInit {
  @Input("otherPaymentsModal") otherPaymentsModal: boolean | null = false;
  @Input("totalAmtTobePaid") totalAmtTobePaid = 0;
  @Input("showCreditBalance") showCreditBalance: boolean = false;
  @Input("creditBalance") creditBalance: number = 0;
  @Input("minimumPaymentRequiredPerc") minimumPaymentRequiredPerc: number = 0;
  @Input("IsMinimumPaymentRequired") IsMinimumPaymentRequired: boolean = false;
  @Input("isCashRecurring") isCashRecurring: boolean = true;
  @Input("showCreditBalanceForClientCredit") showCreditBalanceForClientCredit: boolean = false;


  @Output() closeOtherPaymentDialog = new EventEmitter()
  @Output() hideOtherPaymentDialog: EventEmitter<{
    hideSidebar: boolean;
    paymentSignUp: PaymentSignUp | null;
  }> = new EventEmitter();

  onlinePayment = false;
  otherpayment = true;

  //#region  "Static Payments"
  isCashAllowed = false;
  isDebitCardAllowed = false;
  isCreditCardAllowed = false;
  isNetBankingAllowed = false;
  isUpiAllowed = false;
  isWalletAllowed = false;
  isAmazonPayAllowed = false;
  isPayTMAllowed = false;
  isVenmoAllowed = false;
  isChequeAllowed = false;
  isCreditBalanceAllowed = true;
  tenantId = 0;


  //#endregion

  paymentModes$ = new BehaviorSubject<PaymentModeMastersResponse[]>([]);
  paymentModeMaster$: Observable<ListPaymentModeMastersResponse> = new Observable();
  paymentModeLevel2$: Observable<ListPaymentModeLevel2CountryMappingResponse> = new Observable();
  totalOneTimeCost$ = new BehaviorSubject<number>(0);
  fgPayment: UntypedFormGroup = new UntypedFormGroup({});
  getAccessTenantList$: Observable<any>;
  claim$: Observable<Claim[]> = new Observable();
  countryCode = "";


  isCashAllowed$ = new BehaviorSubject<boolean>(false);
  isDebitCardAllowed$ = new BehaviorSubject<boolean>(false);
  isCreditCardAllowed$ = new BehaviorSubject<boolean>(false);
  isNetBankingAllowed$ = new BehaviorSubject<boolean>(false);
  isUpiAllowed$ = new BehaviorSubject<boolean>(false);
  isWalletAllowed$ = new BehaviorSubject<boolean>(false);
  isAmazonPayAllowed$ = new BehaviorSubject<boolean>(false);
  isPayTMAllowed$ = new BehaviorSubject<boolean>(false);
  isVenmoAllowed$ = new BehaviorSubject<boolean>(false);
  isChequeAllowed$ = new BehaviorSubject<boolean>(false);
  isACHAllowed$ = new BehaviorSubject<boolean>(false);
  isSodexoAllowed$ = new BehaviorSubject<boolean>(false);
  isCreditBalanceAllowed$ = new BehaviorSubject<boolean>(true);
  isSubmitting = false;
  currencySymbol$ = new BehaviorSubject<string>('');

  locale:string = navigator.language;


  constructor(
    private commonService: CommonService,
    public paymentModeService: PaymentModeService,
    private fb: UntypedFormBuilder,
    private store: Store,
    private translate: TranslateService,
    private claimService: ClaimService,
    private commmonService:CommonService
  ) {
    this.SetFormFields();
  }


  ngOnInit(): void {
    if(this.locale =='ar') this.locale ="ar-SA";
    this.componentInit();
    if (Statsig.checkGate("customer_credit_balance")) {
      this.showCreditBalance = true;
    } else {
      this.showCreditBalance = false;
    }
    this.totalOneTimeCost$.next(this.totalAmtTobePaid);
    this.BindPaymentModeLevel2(this.countryCode);
    this.createDymamicPaymentControl();
    this.BindOtherPaymentMode(this.tenantId);
    this.setPaymentValidator();
    this.paymentModeValidationSet();
    //}, 1000);
  }

  componentInit() {
    const companyInfoDetail$: Observable<any> = this.store.select(COMPANY_INFO);
    this.getAccessTenantList$ = this.store.select(TENANTS_INFO);
    this.claim$ = this.claimService.GetClaim(environment.BASE_URL);

    this.getAccessTenantList$.subscribe((tenant: TENANTSINTERFACE) => {
      this.tenantId = tenant.selected_tenant.id;
      this.countryCode = tenant.selected_tenant.country;
      if (this.tenantId > 0) {
        this.store.dispatch({ type: 'ROUTER_GO' });
      }
    });

    companyInfoDetail$.subscribe((responseData) => {
      this.translate.setDefaultLang(responseData?.selectedLang?.LANG_CODE);
      this.translate.use(responseData?.selectedLang?.LANG_CODE);
    });

    this.store.select(TENANTS_INFO).subscribe((tenant: TENANTSINTERFACE) => {
      this.tenantId = tenant.selected_tenant.id;
      if (this.tenantId > 0) {
        this.store.dispatch({ type: 'ROUTER_GO' });
      }
    });

    this.store.select(COUNTRY_MASTER_STATE).subscribe((country) => {
      this.currencySymbol$.next(getCurrencySymbol(
        country.currency_code,
        'narrow',
        this.locale
      ));
    });
  }

  SetFormFields(): void {
    this.fgPayment = this.fb.group({
      otherPaymentMode: new UntypedFormControl('cash', [Validators.required]),
      //CASH
      frmCashAmount: new UntypedFormControl(0, [
        Validators.required,
        Validators.min(0),
      ]),

      //Credit CARD
      frmCCNumber: new UntypedFormControl('', [Validators.maxLength(4)]),
      frmCCNetworkType: new UntypedFormControl('', []),
      frmCCExpiryDate: new UntypedFormControl('', []),
      frmCCAuthCode: new UntypedFormControl('', []),
      frmCCAmt: new UntypedFormControl('', [
        Validators.required,
        Validators.min(0),
      ]),

      //Credit CARD
      frmDCNumber: new UntypedFormControl('', [Validators.maxLength(4)]),
      frmDCNetworkType: new UntypedFormControl(null, []),
      frmDCExpiryDate: new UntypedFormControl(null, []),
      frmDCAuthCode: new UntypedFormControl('', []),
      frmDCAmt: new UntypedFormControl('', [
        Validators.required,
        Validators.min(0),
      ]),

      //CHEQUE
      frmChequeBankName: new UntypedFormControl('', [Validators.required]),
      frmChequeDate: new UntypedFormControl('', [Validators.required]),
      frmChequeAmount: new UntypedFormControl('', [
        Validators.required,
        Validators.min(0.0001),
      ]),

      //UPI
      frmUpiProvider: new UntypedFormControl('', [Validators.required]),
      frmUpiVpaid: new UntypedFormControl('', [Validators.required]),
      frmUpiAmount: new UntypedFormControl('', [
        Validators.required,
        Validators.min(0.0001),
      ]),
      frmCreditBalanceAmount: new UntypedFormControl(''),
    });

  }

  paymentModeValidationSet() {
    this.totalOneTimeCost$.subscribe({
      next: (val: number) => {
        var creditAmount = 0;
        if (this.CreditBalanceFormControl && this.CreditBalanceFormControl.value) {
          creditAmount = this.commonService.ConvertAmountFromMinorCurrency(this.creditBalance);
        }

        this.frmCash_AmountFormControl.addValidators([
          Validators.max(Math.max(0, (this.commonService.ConvertAmountFromMinorCurrency(val) - creditAmount))),
        ]);

        this.frmCheque_AmountFormControl.addValidators([
          Validators.max(Math.max(0, (this.commonService.ConvertAmountFromMinorCurrency(val) - creditAmount))),
        ]);


        this.frmCC_AmountFormControl.addValidators([
          Validators.max(Math.max(0, (this.commonService.ConvertAmountFromMinorCurrency(val) - creditAmount))),
        ]);


        this.frmDC_AmountFormControl.addValidators([
          Validators.max(Math.max(0, (this.commonService.ConvertAmountFromMinorCurrency(val) - creditAmount))),
        ]);

        this.frmUpi_AmountFormControl.addValidators([
          Validators.max(Math.max(0, (this.commonService.ConvertAmountFromMinorCurrency(val) - creditAmount))),
        ]);


        if (this.IsMinimumPaymentRequired) {
          this.frmCash_AmountFormControl.setValue('');
          this.frmCash_AmountFormControl.addValidators([
            Validators.min(Math.max(0, (this.calculateMInAmount(this.commonService.ConvertAmountFromMinorCurrency(val), this.minimumPaymentRequiredPerc) - creditAmount))),
          ]);
          this.frmCC_AmountFormControl.addValidators([
            Validators.min(Math.max(0, (this.calculateMInAmount(this.commonService.ConvertAmountFromMinorCurrency(val), this.minimumPaymentRequiredPerc) - creditAmount))),
          ]);
          this.frmDC_AmountFormControl.addValidators([
            Validators.min(Math.max(0, (this.calculateMInAmount(this.commonService.ConvertAmountFromMinorCurrency(val), this.minimumPaymentRequiredPerc) - creditAmount))),
          ]);
          this.frmUpi_AmountFormControl.addValidators([
            Validators.min(Math.max(0, (this.calculateMInAmount(this.commonService.ConvertAmountFromMinorCurrency(val), this.minimumPaymentRequiredPerc) - creditAmount))),
          ]);
        }
        else{
          this.frmCash_AmountFormControl.setValue(0);
        }
        this.frmCash_AmountFormControl.updateValueAndValidity();
        this.frmCheque_AmountFormControl.updateValueAndValidity();
        this.frmCC_AmountFormControl.updateValueAndValidity();
        this.frmDC_AmountFormControl.updateValueAndValidity();
        this.frmUpi_AmountFormControl.updateValueAndValidity();


        Object.keys(this.fgPayment.controls).forEach((key) => {
          if (key.toLowerCase().startsWith('inp_otherpaymentmode_')) {
            this.fgPayment.controls[key].addValidators([
              Validators.max(Math.max(0, (this.commonService.ConvertAmountFromMinorCurrency(val) - creditAmount))),
            ]);
            if (this.IsMinimumPaymentRequired) {
              this.fgPayment.controls[key].addValidators([
                Validators.min(Math.max(0, (this.calculateMInAmount(this.commonService.ConvertAmountFromMinorCurrency(val), this.minimumPaymentRequiredPerc) - creditAmount))),
              ]);
            }
            this.fgPayment.controls[key].updateValueAndValidity();
          }
        });
      },
      error: () => { },
    });
  }

  changePaymentMode(evt: any) { }

  createDymamicPaymentControl() {
    this.fgPayment.addControl(
      'frmCreditBalanceAmount',
      new UntypedFormControl('', [])
    );
    this.paymentModes$.subscribe({
      next: (paymentModeMastersResponse: PaymentModeMastersResponse[]) => {
        paymentModeMastersResponse.forEach(
          (value: PaymentModeMastersResponse) => {
            this.fgPayment.addControl(
              'inp_otherPaymentMode_' + value.id.toString(),
              new UntypedFormControl(0, [])
            );
            if (this.checkPaymentModeTabbyTamara(value)) {
              this.fgPayment.addControl('inp_otherPaymentMode_refno' + value.id.toString(), new UntypedFormControl('', []));
            }
          }
        );
      },
      error: (error) => {
        if (error instanceof NotFoundError) {
        } else {
        }
      },
    });

    this.fgPayment.controls.frmCreditBalanceAmount.valueChanges.subscribe(
      (value: boolean) => {
        if (value) {
          this.updatePaymentModeMaxAmount(true);
          this.updatePaymentModeMinAmount(true);
        }
        else {
          this.updatePaymentModeMaxAmount(false);
          this.updatePaymentModeMinAmount(false);
        }
      }
    );
  }

  BindOtherPaymentMode(tenant_id: number) {
    this.paymentModeMaster$ = this.paymentModeService.listPaymentMode(tenant_id);
    this.paymentModeMaster$.subscribe({
      next: (listpaymentMode: ListPaymentModeMastersResponse) => {
        CONSTANTS_DATA.PAYMENTMODE.IN.forEach((obj) => {
          listpaymentMode.items.push(obj as any);
        });

        this.paymentModes$.next(
          listpaymentMode.items.filter((e) => {
            return (
              (e.status == Status.Active ||
                e.status.toString() == Status[Status.Active]) &&
              (e.type == PayModeLevel1.Other ||
                e.type.toString() == PayModeLevel1[PayModeLevel1.Other])
            );
          })
        );
      },
      error: (error) => {
        if (error instanceof NotFoundError) {
        } else {
        }
      },
    });
  }

  updatePaymentModeMaxAmount(isCreditAmountApplied: boolean) {
    this.totalOneTimeCost$.subscribe({
      next: (amount: number) => {
        this.frmCash_AmountFormControl.clearValidators();
        this.frmCheque_AmountFormControl.clearValidators();
        this.frmCC_AmountFormControl.clearValidators();
        this.frmDC_AmountFormControl.clearValidators();
        this.frmUpi_AmountFormControl.clearValidators();
        var creditAmount = 0;
        if (isCreditAmountApplied) {
          creditAmount = this.commonService.ConvertAmountFromMinorCurrency(this.creditBalance);
        }
        var method = this.fgPayment.controls['otherPaymentMode'].value;
        let otherPaymentModeid = 0;
        if (method.toLowerCase().startsWith('otherpaymentmode_rb_')) {
          otherPaymentModeid = parseInt(
            method.toLowerCase().replace('otherpaymentmode_rb_', '')
          );
          method = 'otherpaymentmode';
        }
        switch (method) {
          case 'cash':
            if (isCreditAmountApplied && this.creditBalance > amount)
              this.frmCash_AmountFormControl.clearValidators();
            else
              this.frmCash_AmountFormControl.addValidators([Validators.required]);
            this.frmCash_AmountFormControl.addValidators([
              Validators.max(Math.max(0, (this.commonService.ConvertAmountFromMinorCurrency(amount) - creditAmount))),
            ]);
            this.frmCash_AmountFormControl.updateValueAndValidity();
            break;
          case 'cheque':
            if (isCreditAmountApplied && this.creditBalance > amount)
              this.frmCheque_AmountFormControl.clearValidators();
            else
              this.frmCheque_AmountFormControl.addValidators([
                Validators.required,
              ]);
            this.frmCheque_AmountFormControl.addValidators([
              Validators.max(Math.max(0, (this.commonService.ConvertAmountFromMinorCurrency(amount) - creditAmount))),
            ]);
            this.frmCheque_AmountFormControl.updateValueAndValidity();
            break;
          case 'upi':
            if (isCreditAmountApplied && this.creditBalance > amount)
              this.frmUpi_AmountFormControl.clearValidators();
            else
              this.frmUpi_AmountFormControl.addValidators([Validators.required]);
            this.frmUpi_AmountFormControl.addValidators([
              Validators.max(Math.max(0, (this.commonService.ConvertAmountFromMinorCurrency(amount) - creditAmount))),
            ]);
            this.frmUpi_AmountFormControl.updateValueAndValidity();
            break;
          case 'debit':
            if (isCreditAmountApplied && this.creditBalance > amount)
              this.frmDC_AmountFormControl.clearValidators();
            else
              this.frmDC_AmountFormControl.addValidators([Validators.required]);
            this.frmDC_AmountFormControl.addValidators([
              Validators.max(Math.max(0, (this.commonService.ConvertAmountFromMinorCurrency(amount) - creditAmount))),
            ]);
            this.frmDC_AmountFormControl.updateValueAndValidity();
            break;
          case 'credit':
            if (isCreditAmountApplied && this.creditBalance > amount)
              this.frmCC_AmountFormControl.clearValidators();
            else
              this.frmCC_AmountFormControl.addValidators([Validators.required]);
            this.frmCC_AmountFormControl.addValidators([
              Validators.max(Math.max(0, (this.commonService.ConvertAmountFromMinorCurrency(amount) - creditAmount))),
            ]);
            this.frmCC_AmountFormControl.updateValueAndValidity();
            break;
          case 'otherpaymentmode':
            this.fgPayment.controls['inp_otherPaymentMode_' + otherPaymentModeid].addValidators([Validators.required]);
            this.fgPayment.controls['inp_otherPaymentMode_' + otherPaymentModeid].addValidators([
              Validators.max(Math.max(0, (this.commonService.ConvertAmountFromMinorCurrency(amount) - creditAmount))),
            ]);
            this.fgPayment.controls['inp_otherPaymentMode_' + otherPaymentModeid].updateValueAndValidity();
            break;
        }
      },
      error: () => { },
    });
  }

  updatePaymentModeMinAmount(isCreditAmountApplied: boolean) {
    if (this.IsMinimumPaymentRequired) {
      this.totalOneTimeCost$.subscribe({
        next: (amount: number) => {
          this.frmCash_AmountFormControl.clearValidators();
          this.frmCheque_AmountFormControl.clearValidators();
          this.frmCC_AmountFormControl.clearValidators();
          this.frmDC_AmountFormControl.clearValidators();
          this.frmUpi_AmountFormControl.clearValidators();
          var creditAmount = 0;
          if (isCreditAmountApplied) {
            creditAmount = this.commonService.ConvertAmountFromMinorCurrency(this.creditBalance);
          }
          var method = this.fgPayment.controls['otherPaymentMode'].value;
          let otherPaymentModeid = 0;
          if (method.toLowerCase().startsWith('otherpaymentmode_rb_')) {
            otherPaymentModeid = parseInt(
              method.toLowerCase().replace('otherpaymentmode_rb_', '')
            );
            method = 'otherpaymentmode';
          }
          switch (method) {
            case 'cash':
              if (isCreditAmountApplied && this.creditBalance > amount)
                this.frmCash_AmountFormControl.clearValidators();
              else
                this.frmCash_AmountFormControl.addValidators([Validators.required]);
              this.frmCash_AmountFormControl.addValidators([
                Validators.max(Math.max(0, (this.commonService.ConvertAmountFromMinorCurrency(amount) - creditAmount))),
              ]);
              this.frmCash_AmountFormControl.addValidators([
                Validators.min(Math.max(0, (this.calculateMInAmount(this.commonService.ConvertAmountFromMinorCurrency(amount), this.minimumPaymentRequiredPerc) - creditAmount))),
              ]);
              this.frmCash_AmountFormControl.updateValueAndValidity();
              break;
            case 'cheque':
              if (isCreditAmountApplied && this.creditBalance > amount)
                this.frmCheque_AmountFormControl.clearValidators();
              else
                this.frmCheque_AmountFormControl.addValidators([
                  Validators.required,
                ]);
              this.frmCheque_AmountFormControl.addValidators([
                Validators.max(Math.max(0, (this.commonService.ConvertAmountFromMinorCurrency(amount) - creditAmount))),
              ]);
              this.frmCheque_AmountFormControl.addValidators([
                Validators.min(Math.max(0, (this.calculateMInAmount(this.commonService.ConvertAmountFromMinorCurrency(amount), this.minimumPaymentRequiredPerc) - creditAmount))),
              ]);

              this.frmCheque_AmountFormControl.updateValueAndValidity();
              break;
            case 'upi':
              if (isCreditAmountApplied && this.creditBalance > amount)
                this.frmUpi_AmountFormControl.clearValidators();
              else
                this.frmUpi_AmountFormControl.addValidators([Validators.required]);
              this.frmUpi_AmountFormControl.addValidators([
                Validators.max(Math.max(0, (this.commonService.ConvertAmountFromMinorCurrency(amount) - creditAmount))),
              ]);
              this.frmUpi_AmountFormControl.addValidators([
                Validators.min(Math.max(0, (this.calculateMInAmount(this.commonService.ConvertAmountFromMinorCurrency(amount), this.minimumPaymentRequiredPerc) - creditAmount))),
              ]);
              this.frmUpi_AmountFormControl.updateValueAndValidity();
              break;
            case 'debit':
              if (isCreditAmountApplied && this.creditBalance > amount)
                this.frmDC_AmountFormControl.clearValidators();
              else
                this.frmDC_AmountFormControl.addValidators([Validators.required]);
              this.frmDC_AmountFormControl.addValidators([
                Validators.max(Math.max(0, (this.commonService.ConvertAmountFromMinorCurrency(amount) - creditAmount))),
              ]);
              this.frmDC_AmountFormControl.addValidators([
                Validators.min(Math.max(0, (this.calculateMInAmount(this.commonService.ConvertAmountFromMinorCurrency(amount), this.minimumPaymentRequiredPerc) - creditAmount))),
              ]);
              this.frmDC_AmountFormControl.updateValueAndValidity();

              break;
            case 'credit':
              if (isCreditAmountApplied && this.creditBalance > amount)
                this.frmCC_AmountFormControl.clearValidators();
              else
                this.frmCC_AmountFormControl.addValidators([Validators.required]);
              this.frmCC_AmountFormControl.addValidators([
                Validators.max(Math.max(0, (this.commonService.ConvertAmountFromMinorCurrency(amount) - creditAmount))),
              ]);
              this.frmCC_AmountFormControl.addValidators([
                Validators.min(Math.max(0, (this.calculateMInAmount(this.commonService.ConvertAmountFromMinorCurrency(amount), this.minimumPaymentRequiredPerc) - creditAmount))),
              ]);
              this.frmCC_AmountFormControl.updateValueAndValidity();
              break;
            case 'otherpaymentmode':
              this.fgPayment.controls['inp_otherPaymentMode_' + otherPaymentModeid].addValidators([Validators.required]);
              this.fgPayment.controls['inp_otherPaymentMode_' + otherPaymentModeid].addValidators([
                Validators.min(Math.max(0, (this.calculateMInAmount(this.commonService.ConvertAmountFromMinorCurrency(amount), this.minimumPaymentRequiredPerc) - creditAmount))),
              ]);
              this.fgPayment.controls['inp_otherPaymentMode_' + otherPaymentModeid].updateValueAndValidity();
              break;
          }


        },
        error: () => { },
      });
    }
  }

  setPaymentValidator() {
    this.fgPayment.controls['otherPaymentMode'].valueChanges.subscribe(
      (val) => {
        this.totalOneTimeCost$.subscribe({
          next: (amount: number) => {
            let otherPaymentModeid = 0;
            if (val.toLowerCase().startsWith('otherpaymentmode_rb_')) {
              otherPaymentModeid = parseInt(
                val.toLowerCase().replace('otherpaymentmode_rb_', '')
              );
              val = 'otherpaymentmode';
            }
            var creditAmount = 0;
            if (this.CreditBalanceFormControl && this.CreditBalanceFormControl.value) {
              creditAmount = this.commonService.ConvertAmountFromMinorCurrency(this.creditBalance);
            }
            switch (val) {
              case 'cash':
                this.frmCash_AmountFormControl.clearValidators();
                this.frmCash_AmountFormControl.addValidators([Validators.required]);
                this.frmCash_AmountFormControl.addValidators([
                  Validators.max(Math.max(0, (this.commonService.ConvertAmountFromMinorCurrency(val) - creditAmount))),
                ]);
                if (this.IsMinimumPaymentRequired) {
                  this.frmCash_AmountFormControl.addValidators([
                    Validators.min(Math.max(0, (this.calculateMInAmount(this.commonService.ConvertAmountFromMinorCurrency(amount), this.minimumPaymentRequiredPerc) - creditAmount))),
                  ]);
                }
                this.frmCash_AmountFormControl.updateValueAndValidity();
                break;
              case 'cheque':
                this.frmCheque_AmountFormControl.clearValidators();
                this.frmCheque_AmountFormControl.addValidators([
                  Validators.required,
                ]);
                this.frmCheque_AmountFormControl.addValidators([
                  Validators.max(Math.max(0, (this.commonService.ConvertAmountFromMinorCurrency(amount) - creditAmount))),
                ]);
                if (this.IsMinimumPaymentRequired) {
                  this.frmCheque_AmountFormControl.addValidators([
                    Validators.min(Math.max(0, (this.calculateMInAmount(this.commonService.ConvertAmountFromMinorCurrency(amount), this.minimumPaymentRequiredPerc) - creditAmount))),
                  ]);
                }
                this.frmCheque_AmountFormControl.updateValueAndValidity();
                break;
              case 'upi':
                this.frmUpi_AmountFormControl.clearValidators();
                this.frmUpi_AmountFormControl.addValidators([Validators.required]);
                this.frmUpi_AmountFormControl.addValidators([
                  Validators.max(Math.max(0, (this.commonService.ConvertAmountFromMinorCurrency(amount) - creditAmount))),
                ]);
                if (this.IsMinimumPaymentRequired) {
                  this.frmUpi_AmountFormControl.addValidators([
                    Validators.min(Math.max(0, (this.calculateMInAmount(this.commonService.ConvertAmountFromMinorCurrency(amount), this.minimumPaymentRequiredPerc) - creditAmount))),
                  ]);
                }
                this.frmUpi_AmountFormControl.updateValueAndValidity();
                break;
              case 'debit':
                this.frmDC_AmountFormControl.clearValidators();
                this.frmDC_AmountFormControl.addValidators([Validators.required]);
                this.frmDC_AmountFormControl.addValidators([
                  Validators.max(Math.max(0, (this.commonService.ConvertAmountFromMinorCurrency(amount) - creditAmount))),
                ]);
                if (this.IsMinimumPaymentRequired) {
                  this.frmDC_AmountFormControl.addValidators([
                    Validators.min(Math.max(0, (this.calculateMInAmount(this.commonService.ConvertAmountFromMinorCurrency(amount), this.minimumPaymentRequiredPerc) - creditAmount))),
                  ]);
                }
                this.frmDC_AmountFormControl.updateValueAndValidity();

                break;
              case 'credit':
                this.frmCC_AmountFormControl.clearValidators();
                this.frmCC_AmountFormControl.addValidators([Validators.required]);
                this.frmCC_AmountFormControl.addValidators([
                  Validators.max(Math.max(0, (this.commonService.ConvertAmountFromMinorCurrency(amount) - creditAmount))),
                ]);
                if (this.IsMinimumPaymentRequired) {
                  this.frmCC_AmountFormControl.addValidators([
                    Validators.min(Math.max(0, (this.calculateMInAmount(this.commonService.ConvertAmountFromMinorCurrency(amount), this.minimumPaymentRequiredPerc) - creditAmount))),
                  ]);
                }
                this.frmCC_AmountFormControl.updateValueAndValidity();
                break;
              case 'otherpaymentmode':
                this.fgPayment.controls['inp_otherPaymentMode_' + otherPaymentModeid].addValidators([Validators.required]);
                this.fgPayment.controls['inp_otherPaymentMode_' + otherPaymentModeid].updateValueAndValidity();
                if (this.IsMinimumPaymentRequired) {
                  this.fgPayment.controls['inp_otherPaymentMode_' + otherPaymentModeid].addValidators([
                    Validators.min(Math.max(0, (this.calculateMInAmount(this.commonService.ConvertAmountFromMinorCurrency(amount), this.minimumPaymentRequiredPerc) - creditAmount))),
                  ]);
                }
                if (this.fgPayment.controls['inp_otherPaymentMode_refno' + otherPaymentModeid]) {
                  this.fgPayment.controls['inp_otherPaymentMode_refno' + otherPaymentModeid].addValidators([Validators.required]);
                  this.fgPayment.controls['inp_otherPaymentMode_refno' + otherPaymentModeid].updateValueAndValidity();
                }
                break;
            }
          }
        });
      }
    );
  }

  clearPaymentValidator() {
    this.frmCash_AmountFormControl.removeValidators([Validators.required]);
    this.frmCheque_AmountFormControl.removeValidators([Validators.required]);
    this.frmUpi_AmountFormControl.removeValidators([Validators.required]);
    this.frmDC_AmountFormControl.removeValidators([Validators.required]);
    this.frmCC_AmountFormControl.removeValidators([Validators.required]);
    Object.keys(this.fgPayment.controls).forEach((key) => {
      if (key.toLowerCase().startsWith('inp_otherpaymentmode_')) {
        this.fgPayment.controls[key].removeValidators([Validators.required]);
      }
    });
    this.frmCheque_AmountFormControl.updateValueAndValidity();
  }

  getPaymentObject() {
    const paymentSignUp = {} as PaymentSignUp;
    var mode = this.otherPaymentMethod;
    var otherPaymentModeid = 0;
    paymentSignUp.vpa_id = '';
    paymentSignUp.upi_provider = '';
    paymentSignUp.network_type = '';
    paymentSignUp.card_number = '';
    paymentSignUp.bank_name = '';
    paymentSignUp.auth_code = '';
    paymentSignUp.cheque_date = new Date();
    paymentSignUp.exp_date = new Date();


    if (mode.toLowerCase().startsWith('otherpaymentmode_rb_')) {
      otherPaymentModeid = parseInt(
        mode.toLowerCase().replace('otherpaymentmode_rb_', '')
      );
      paymentSignUp.other_paymode_master_id = otherPaymentModeid;
      mode = 'otherpaymentmode';
    }
    if (this.CreditBalanceFormControl.value && this.CreditBalanceFormControl.value == true) {
      paymentSignUp.is_credit_balance_used = true;
      if (this.creditBalance > this.totalAmtTobePaid)
        paymentSignUp.credit_balance_amount_in_minor_currency = this.totalAmtTobePaid;
      else {
        paymentSignUp.credit_balance_amount_in_minor_currency = this.creditBalance;
      }
    }
    else {
      paymentSignUp.is_credit_balance_used = false;
      paymentSignUp.credit_balance_amount_in_minor_currency = 0;
    }

    switch (mode) {
      case 'cash':
        paymentSignUp.amount_in_minor_currency =
          this.commonService.ConvertMinorCurrencyFromAmount(
            this.frmCash_Amount
          );
        paymentSignUp.rounded_amount_in_minor_currency =
        this.commonService.ConvertMinorCurrencyFromAmountRounded(
          this.frmCash_Amount
        );
        paymentSignUp.paymode_level1 = PayModeLevel1.Cash;
        paymentSignUp.paymode_level2_id = PayModeLevel2.Cash;
        break;
      case 'cheque':
        paymentSignUp.amount_in_minor_currency =
          this.commonService.ConvertMinorCurrencyFromAmount(
            this.frmCheque_Amount
          );
        paymentSignUp.rounded_amount_in_minor_currency =
        this.commonService.ConvertMinorCurrencyFromAmountRounded(
          this.frmCheque_Amount
        );
        paymentSignUp.cheque_date = this.frmCheque_Date;
        paymentSignUp.bank_name = this.frmCheque_BankName;
        paymentSignUp.paymode_level1 = PayModeLevel1.Cheque;
        paymentSignUp.paymode_level2_id = PayModeLevel2.Cheque;
        break;
      case 'upi':
        paymentSignUp.paymode_level1 = PayModeLevel1.UPI;
        paymentSignUp.paymode_level2_id = PayModeLevel2.UPI;
        paymentSignUp.vpa_id = this.frmUpiVpaid;
        paymentSignUp.upi_provider = this.frmUpiProvider;
        paymentSignUp.amount_in_minor_currency = this.commonService.ConvertMinorCurrencyFromAmount(this.frmUpi_Amount);
        paymentSignUp.rounded_amount_in_minor_currency =
        this.commonService.ConvertMinorCurrencyFromAmountRounded(
          this.frmUpi_Amount
        );
        break;
      case 'debit':
        if (this.frmDC_ExpiryDate) {
            // Create a new date using the given year and month
            const expirationDate = new Date(Number(this.frmDC_ExpiryDate.toString().split('/')[1]), Number(this.frmDC_ExpiryDate.toString().split('/')[0]) - 1, 1);
            // Set the date to the last day of the month
            expirationDate.setMonth(expirationDate.getMonth() + 1);
            expirationDate.setDate(expirationDate.getDate() - 1);
             paymentSignUp.exp_date = expirationDate;
        } else {
             paymentSignUp.exp_date = null;
        }
        paymentSignUp.amount_in_minor_currency = this.commonService.ConvertMinorCurrencyFromAmount(this.frmDC_Amount);
        paymentSignUp.rounded_amount_in_minor_currency =
        this.commonService.ConvertMinorCurrencyFromAmountRounded(
          this.frmDC_Amount
        );
        paymentSignUp.network_type = this.frmDC_NetworkType;
        paymentSignUp.card_number = 'XXXX-XXXX-XXXX-' + this.frmDC_Number.toString();
        paymentSignUp.auth_code = this.frmDC_AuthCode.toString();
        paymentSignUp.paymode_level1 = PayModeLevel1.Card;
        paymentSignUp.paymode_level2_id = PayModeLevel2.Debit;
        break;
      case 'credit':
        if (this.frmCC_ExpiryDate) {
           // Create a new date using the given year and month
           const expirationDate = new Date(Number(this.frmCC_ExpiryDate.toString().split('/')[1]), Number(this.frmCC_ExpiryDate.toString().split('/')[0]) - 1, 1);
           // Set the date to the last day of the month
           expirationDate.setMonth(expirationDate.getMonth() + 1);
           expirationDate.setDate(expirationDate.getDate() - 1);
           paymentSignUp.exp_date = expirationDate;
        } else {
          paymentSignUp.exp_date = null;
        }

        paymentSignUp.amount_in_minor_currency = this.commonService.ConvertMinorCurrencyFromAmount(this.frmCC_Amount);
        paymentSignUp.rounded_amount_in_minor_currency =
        this.commonService.ConvertMinorCurrencyFromAmountRounded(
          this.frmCC_Amount
        );
        paymentSignUp.network_type = this.frmCC_NetworkType;
        paymentSignUp.card_number = 'XXXX-XXXX-XXXX-' + this.frmCC_Number.toString();
        paymentSignUp.auth_code = this.frmCC_AuthCode.toString();
        paymentSignUp.paymode_level1 = PayModeLevel1.Card;
        paymentSignUp.paymode_level2_id = PayModeLevel2.Credit;
        break;
      case 'otherpaymentmode':
        paymentSignUp.amount_in_minor_currency =
          this.commonService.ConvertMinorCurrencyFromAmount(
            this.fgPayment.controls[
              'inp_otherPaymentMode_' + otherPaymentModeid
            ].value
          );
        paymentSignUp.rounded_amount_in_minor_currency =
          this.commonService.ConvertMinorCurrencyFromAmountRounded(
            this.fgPayment.controls[
              'inp_otherPaymentMode_' + otherPaymentModeid
            ].value
          );
        paymentSignUp.paymode_level1 = PayModeLevel1.Other;
        paymentSignUp.auth_code = this.fgPayment.controls['inp_otherPaymentMode_refno' + otherPaymentModeid] ? this.fgPayment.controls['inp_otherPaymentMode_refno' + otherPaymentModeid].value : '';
        break;
    }
    return paymentSignUp;
  }


  closePaymentPopup(isClosed: boolean) {
    this.isSubmitting = true;
    if (!isClosed) {
      this.fgPayment.markAllAsTouched();
      let paymentObject= this.getPaymentObject();
      if (!this.validatePaymentObject()) {
        this.isSubmitting = false;
        return false;
      }
      if(this.IsMinimumPaymentRequired && !this.CheckMinimumPaymentAmountRequiredValid(paymentObject.amount_in_minor_currency + paymentObject.credit_balance_amount_in_minor_currency))
      {
        this.isSubmitting= false;
        return false;
      }
    }
    this.hideOtherPaymentDialog.emit({
      hideSidebar: false,
      paymentSignUp: (!isClosed) ? this.getPaymentObject() : null
    });
    this.isSubmitting = false;
    this.otherPaymentsModal = false;
    return true;
  }

  validatePaymentObject(): boolean {
    var mode = this.otherPaymentMethod;
    var otherPaymentModeid = 0;
    var isValid = true;

    if (mode.toLowerCase().startsWith('otherpaymentmode_rb_')) {
      otherPaymentModeid = parseInt(
        mode.toLowerCase().replace('otherpaymentmode_rb_', '')
      );
      mode = 'otherpaymentmode';
    }

    switch (mode) {
      case 'cash':
        if (this.frmCash_AmountFormControl.status == 'INVALID') isValid = false;
        break;
      case 'cheque':
        if (
          this.frmCheque_AmountFormControl.status == 'INVALID' ||
          this.frmCheque_DateFormControl.status == 'INVALID' ||
          this.frmCheque_BankNameFormControl.status == 'INVALID'
        )
          isValid = false;
        break;
      case 'upi':
        if (
          this.frmUpi_AmountFormControl.status == 'INVALID' ||
          this.frmUpiVpaidFormControl.status == 'INVALID' ||
          this.frmUpiProviderFormControl.status == 'INVALID'
        )
          isValid = false;
        break;
      case 'debit':
        if (
          this.frmDC_AmountFormControl.status == 'INVALID' ||
          this.frmDC_AuthCodeFormControl.status == 'INVALID' ||
          this.frmDC_CardExpiryFormControl.status == 'INVALID' ||
          this.frmDC_NetworkTypeFormControl.status == 'INVALID' ||
          this.frmDC_NumberFormControl.status == 'INVALID'
        )
          isValid = false;
        break;
      case 'credit':
        if (
          this.frmCC_AmountFormControl.status == 'INVALID' ||
          this.frmCC_AuthCodeFormControl.status == 'INVALID' ||
          this.frmCC_CardExpiryFormControl.status == 'INVALID' ||
          this.frmCC_NetworkTypeFormControl.status == 'INVALID' ||
          this.frmCC_NumberFormControl.status == 'INVALID'
        )
          isValid = false;
        break;
      case 'otherpaymentmode':
        if (this.fgPayment.controls['inp_otherPaymentMode_' + otherPaymentModeid].status == 'INVALID')
          isValid = false;
        if (this.fgPayment.controls['inp_otherPaymentMode_refno' + otherPaymentModeid] && this.fgPayment.controls['inp_otherPaymentMode_refno' + otherPaymentModeid].status == 'INVALID') {
          this.fgPayment.controls['inp_otherPaymentMode_refno' + otherPaymentModeid].markAsTouched();
          isValid = false;
        }

        break;
    }
    return isValid;
  }


  getPaymentBalance(totalAmt: number, ctrl: string) {
    return this.commonService.ConvertMinorCurrencyFromAmount(
      this.commonService.ConvertAmountFromMinorCurrency(totalAmt) -
      this.fgPayment.get('inp_otherPaymentMode_' + ctrl.toString())?.value
    );
  }

  getfrmCash_Amount() {
    return this.commonService.ConvertMinorCurrencyFromAmount(
      this.frmCash_Amount
    );
  }

  getfrmCheque_Amount() {
    return this.commonService.ConvertMinorCurrencyFromAmount(
      this.frmCheque_Amount
    );
  }

  getfrmUpi_Amount() {
    return this.commonService.ConvertMinorCurrencyFromAmount(
      this.frmUpi_Amount
    );
  }

  getfrmCC_Amount() {
    return this.commonService.ConvertMinorCurrencyFromAmount(this.frmCC_Amount);
  }

  getfrmDC_Amount() {
    return this.commonService.ConvertMinorCurrencyFromAmount(this.frmDC_Amount);
  }

  getRemainingAmount(billAmount: number, inputAmount: number) {
    if (this.CreditBalanceFormControl.value)
      return Math.max(0, (billAmount - inputAmount - this.creditBalance));
    else return Math.max(0, (billAmount - inputAmount));
  }

  getAvailableCreitbalance() {
    if (this.CreditBalanceFormControl.value) {
      var balance: number = 0;
      this.totalOneTimeCost$.subscribe({
        next: (amount: number) => {
          balance = Math.max(0, (this.creditBalance - amount));
        }
      })
      return balance;
    }
    else return this.creditBalance;
  }

  getRequiredAmount() {
    return this.commmonService.ConvertAmountFromMinorCurrency(this.calculateMInAmount(this.totalAmtTobePaid, this.minimumPaymentRequiredPerc));
  }


  calculateMInAmount(givenAmount: number, percent: number): number {
    // Calculate the amount based on the percentage
    const amount = (givenAmount * percent) / 100;
    return amount;
  }

  getTotalAmountInCurrency() {
    return this.commmonService.ConvertAmountFromMinorCurrency(this.totalAmtTobePaid);
  }

  CheckMinimumPaymentAmountRequiredValid(paymentAmount: number) {
    let isValid = true;
    if (this.commmonService.ConvertAmountFromMinorCurrency(paymentAmount) >= this.calculateMInAmount(this.getTotalAmountInCurrency(), this.minimumPaymentRequiredPerc))
      isValid = true
    else isValid = false;
    return isValid;
  }

  closePopup(){
    this.otherPaymentsModal= false;
    this.closeOtherPaymentDialog.emit(true);
  }
  //#region "Payment"

  //#region Dynamic Control

  get otherPaymentMethodFormControl(): UntypedFormControl {
    return this.fgPayment.controls.otherPaymentMode as UntypedFormControl;
  }

  get otherPaymentMethod(): string {
    return this.otherPaymentMethodFormControl.value as string;
  }

  set otherPaymentMethod(val: string) {
    this.otherPaymentMethodFormControl.setValue(val);
  }

  //#endregion Dynamic Control

  //#region Credit Card

  get frmCC_NumberFormControl(): UntypedFormControl {
    return this.fgPayment.controls.frmCCNumber as UntypedFormControl;
  }

  get frmCC_Number(): number {
    return this.frmCC_NumberFormControl.value as number;
  }

  set frmCC_Number(val: number) {
    this.frmCC_NumberFormControl.setValue(val);
  }

  get frmCC_NetworkTypeFormControl(): UntypedFormControl {
    return this.fgPayment.controls.frmCCNetworkType as UntypedFormControl;
  }

  get frmCC_NetworkType(): string {
    return this.frmCC_NetworkTypeFormControl.value as string;
  }

  set frmCC_NetworkType(val: string) {
    this.frmCC_NetworkTypeFormControl.setValue(val);
  }

  get frmCC_CardExpiryFormControl(): UntypedFormControl {
    return this.fgPayment.controls.frmCCExpiryDate as UntypedFormControl;
  }

  get frmCC_ExpiryDate(): string {
    return this.frmCC_CardExpiryFormControl.value as string;
  }

  set frmCC_ExpiryDate(val: string) {
    this.frmCC_CardExpiryFormControl.setValue(val);
  }

  get frmCC_AuthCodeFormControl(): UntypedFormControl {
    return this.fgPayment.controls.frmCCAuthCode as UntypedFormControl;
  }

  get frmCC_AuthCode(): number {
    return this.frmCC_AuthCodeFormControl.value as number;
  }

  set frmCC_AuthCode(val: number) {
    this.frmCC_AuthCodeFormControl.setValue(val);
  }

  get frmCC_AmountFormControl(): UntypedFormControl {
    return this.fgPayment.controls.frmCCAmt as UntypedFormControl;
  }

  get frmCC_Amount(): number {
    return this.frmCC_AmountFormControl.value as number;
  }

  set frmCC_Amount(val: number) {
    this.frmCC_AmountFormControl.setValue(val);
  }
  //#endregion Credit Card

  //#region Debit Card
  get frmDC_NumberFormControl(): UntypedFormControl {
    return this.fgPayment.controls.frmDCNumber as UntypedFormControl;
  }

  get frmDC_Number(): number {
    return this.frmDC_NumberFormControl.value as number;
  }

  set frmDC_Number(val: number) {
    this.frmDC_NumberFormControl.setValue(val);
  }

  get frmDC_NetworkTypeFormControl(): UntypedFormControl {
    return this.fgPayment.controls.frmDCNetworkType as UntypedFormControl;
  }

  get frmDC_NetworkType(): string {
    return this.frmDC_NetworkTypeFormControl.value as string;
  }

  get frmDC_CardExpiryFormControl(): UntypedFormControl {
    return this.fgPayment.controls.frmDCExpiryDate as UntypedFormControl;
  }

  get frmDC_ExpiryDate(): string {
    return this.frmDC_CardExpiryFormControl.value as string;
  }

  set frmDC_ExpiryDate(val: string) {
    this.frmDC_CardExpiryFormControl.setValue(val);
  }

  get frmDC_AuthCodeFormControl(): UntypedFormControl {
    return this.fgPayment.controls.frmDCAuthCode as UntypedFormControl;
  }

  get frmDC_AuthCode(): number {
    return this.frmDC_AuthCodeFormControl.value as number;
  }

  set frmDC_AuthCode(val: number) {
    this.frmDC_AuthCodeFormControl.setValue(val);
  }

  get frmDC_AmountFormControl(): UntypedFormControl {
    return this.fgPayment.controls.frmDCAmt as UntypedFormControl;
  }

  get frmDC_Amount(): number {
    return this.frmDC_AmountFormControl.value as number;
  }

  set frmDC_Amount(val: number) {
    this.frmDC_AmountFormControl.setValue(val);
  }
  //#endregion Debit Card

  //#region Cheque
  get frmCheque_BankNameFormControl(): UntypedFormControl {
    return this.fgPayment.controls.frmChequeBankName as UntypedFormControl;
  }

  get frmCheque_BankName(): string {
    return this.frmCheque_BankNameFormControl.value as string;
  }

  set frmCheque_BankName(val: string) {
    this.frmCheque_BankNameFormControl.setValue(val);
  }

  get frmCheque_DateFormControl(): UntypedFormControl {
    return this.fgPayment.controls.frmChequeDate as UntypedFormControl;
  }

  get frmCheque_Date(): Date {
    return this.frmCheque_DateFormControl.value as Date;
  }

  set frmCheque_Date(val: Date) {
    this.frmCheque_DateFormControl.setValue(val);
  }

  get frmCheque_AmountFormControl(): UntypedFormControl {
    return this.fgPayment.controls.frmChequeAmount as UntypedFormControl;
  }

  get frmCheque_Amount(): number {
    return this.frmCheque_AmountFormControl.value as number;
  }

  set frmCheque_Amount(val: number) {
    this.frmCheque_AmountFormControl.setValue(val);
  }
  //#endregion Debit Card

  //#region UPI

  get frmCash_AmountFormControl(): UntypedFormControl {
    return this.fgPayment.controls.frmCashAmount as UntypedFormControl;
  }

  get frmCash_Amount(): number {
    return this.frmCash_AmountFormControl.value as number;
  }

  set frmCash_Amount(val: number) {
    this.frmCash_AmountFormControl.setValue(val);
  }

  //#endregion UPI

  //#region Cash

  get frmUpi_AmountFormControl(): UntypedFormControl {
    return this.fgPayment.controls.frmUpiAmount as UntypedFormControl;
  }

  get frmUpi_Amount(): number {
    return this.frmUpi_AmountFormControl.value as number;
  }

  set frmUpi_Amount(val: number) {
    this.frmUpi_AmountFormControl.setValue(val);
  }

  get frmUpiProviderFormControl(): UntypedFormControl {
    return this.fgPayment.controls.frmUpiProvider as UntypedFormControl;
  }

  get frmUpiProvider(): string {
    return this.frmUpiProviderFormControl.value as string;
  }

  set frmUpiProvider(val: string) {
    this.frmUpiProviderFormControl.setValue(val);
  }

  get frmUpiVpaidFormControl(): UntypedFormControl {
    return this.fgPayment.controls.frmUpiVpaid as UntypedFormControl;
  }

  get frmUpiVpaid(): string {
    return this.frmUpiVpaidFormControl.value as string;
  }

  set frmUpiVpaid(val: string) {
    this.frmUpiVpaidFormControl.setValue(val);
  }

  get CreditBalanceFormControl(): UntypedFormControl {
    return this.fgPayment.controls.frmCreditBalanceAmount as UntypedFormControl;
  }


  BindPaymentModeLevel2(countryCode: string) {
    this.isCashAllowed$.next(true);
    this.isDebitCardAllowed$.next(true);
    this.isCreditCardAllowed$.next(true);
    this.isNetBankingAllowed$.next(true);
    this.isUpiAllowed$.next(true);
    this.isPayTMAllowed$.next(true);
    this.isAmazonPayAllowed$.next(true);
    this.isVenmoAllowed$.next(true);
    this.isACHAllowed$.next(true);
    this.isChequeAllowed$.next(true);
    this.isSodexoAllowed$.next(true);
  }

  checkPaymentModeTabbyTamara(paymentMode: PaymentModeMastersResponse): boolean {
    if ((paymentMode.name_primary_language.toLowerCase() == 'tabby' || paymentMode.name_secondary_language.toLowerCase() == 'tabby')
      || (paymentMode.name_primary_language.toLowerCase() == 'tamara' || paymentMode.name_secondary_language.toLowerCase() == 'tamara')
      || (paymentMode.name_primary_language.toLowerCase() == 'spotii' || paymentMode.name_secondary_language.toLowerCase() == 'spotii')
      || (paymentMode.name_primary_language.toLowerCase() == 'online payment' || paymentMode.name_secondary_language.toLowerCase() == 'online payment')
      || (paymentMode.name_primary_language.toLowerCase() == 'madfu' || paymentMode.name_secondary_language.toLowerCase() == 'madfu')) {
      return true;
    }
    else return false;
  }

  getFormControlByName(fornControlname: string): UntypedFormControl {
    return this.fgPayment.get(fornControlname) as UntypedFormControl;
  }
}